import { Grid } from '@material-ui/core';
import Axios from 'axios';
import React, { Fragment, useEffect, useState } from 'react';
import withErrorHandler from '../../hoc/withErrorHandler/withErrorHandler';
import BarChartNps from './components/BarChartNps';
import NpsScore from './components/NpsScore';
import TopEmpresas from './components/TopEmpresas';
import classes from './Nps.module.css';

const Nps = () => {
	//Filters
	function formatDate(date) {
		var d = new Date(date),
			month = '' + (d.getMonth() + 1),
			day = '' + d.getDate(),
			year = d.getFullYear();

		if (month.length < 2) month = '0' + month;
		if (day.length < 2) day = '0' + day;

		const dateFormat = [year, month, day].join('-');
		return dateFormat.toString();
	}

	const firstDateFilter = new Date();
	const date1 = formatDate(firstDateFilter.setMonth(firstDateFilter.getMonth() - 12));

	//Filters
	const [country, setCountry] = useState('Todos');
	const [clasificacion, setClasificacion] = useState(0);
	const [initialDate, setInitialDate] = useState(date1);

	//Apis
	const [npsHistoricoUrl, setNpsHistoricoUrl] = useState(`/getNpsHistoricalDataByDate?dateFrom=${date1}`);
	const [npsTopUrl, setNpsTopUrl] = useState(`/getDataNpsEmpresas?dateFrom=${date1}&isActive=1`);

	//Data
	const [npsHistorico, setDataNpsHistorico] = useState([]);
	const [npsTop, setDataNpsTop] = useState([]);

	//Aux
	const [isLoading, setIsLoading] = useState(false);
	const [isError, setIsError] = useState(false);

	useEffect(() => {
		const fetchData = async () => {
			setIsError(false);
			setIsLoading(true);
			Axios.all([Axios.get(npsHistoricoUrl), Axios.get(npsTopUrl)])
				.then(
					Axios.spread((obj1, obj2) => {
						try {
							setDataNpsHistorico(obj1.data);
							setDataNpsTop(obj2.data);
						} catch (error) {
							setIsError(true);
						}
						setIsLoading(false);
					}),
				)
				.catch((err) => {
					console.log(err);
				});
		};
		fetchData();
	}, [npsHistoricoUrl, npsTopUrl]);

	return (
		<Fragment>
			{/*<FormControl className={classes.formControl}> */}
			<div className={classes.cardFilter}>
				<Grid container direction="row" justify="center" alignItems="center">
					<div className={classes.formup}>
						<form
							onSubmit={(event) => {
								setNpsHistoricoUrl(`/getNpsHistoricalDataByDate?dateFrom=${date1}&pais=${country}&clasificacion=${clasificacion}`);
								setNpsTopUrl(`/getDataNpsEmpresas?dateFrom=${date1}&pais=${country}&clasificacion=${clasificacion}&isActive=1`);
								event.preventDefault();
							}}
						>
							<Grid container spacing={2}>
								<div>
									<select value={country} onChange={(event) => setCountry(event.target.value)}>
										<option value={'Todos'}>Todos los Países</option>
										<option value={'Chile'}>Chile</option>
										<option value={'Peru'}>Peru</option>
										<option value={'Argentina'}>Argentina</option>
									</select>
								</div>

								<div>
									<select value={clasificacion} onChange={(event) => setClasificacion(event.target.value)}>
										<option value={'0'}>Pyme y Corp</option>
										<option value={'1'}>Pyme</option>
										<option value={'2'}>Corp</option>
									</select>
								</div>

								<div>
									<input type="date" id="dateDesde" value={initialDate} onChange={(event) => setInitialDate(event.target.value)} />
								</div>

								<div>
									<input className={classes.buttonRindegastos} type="submit" value="Filtrar" />
								</div>
								{isError && <div>Ups! Algo salió mal...</div>}
							</Grid>
						</form>
					</div>
				</Grid>
			</div>
			<div>
				<br></br>
			</div>
			{/* SECCIÓN 1 */}{' '}
			<Grid item xs={12}>
				<Grid container spacing={2}>
					<NpsScore data={npsHistorico} isLoading={isLoading} />

					<Grid item xs={8}>
						<div className={classes.card}>
							<BarChartNps title="Movimiento Histórico NPS" data={npsHistorico} isLoading={isLoading} />
						</div>
					</Grid>
				</Grid>
			</Grid>
			{/* Sección 2 */}{' '}
			<Grid item xs={12}>
				<TopEmpresas data={npsTop} />
			</Grid>
			{/* Sección 4 */}{' '}
			<Grid item xs={12}>
				<Grid container spacing={2}></Grid>
			</Grid>
		</Fragment>
	);
};

export default React.memo(withErrorHandler(Nps, Axios));
